module.exports = __webpack_public_path__ + "static/media/gif.d3575cac.gif";